import { render, staticRenderFns } from "./ImpBusAgePdfPop.vue?vue&type=template&id=2ab13a67"
import script from "./ImpBusAgePdfPop.vue?vue&type=script&lang=js"
export * from "./ImpBusAgePdfPop.vue?vue&type=script&lang=js"
import style0 from "./ImpBusAgePdfPop.vue?vue&type=style&index=0&id=2ab13a67&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ab13a67')) {
      api.createRecord('2ab13a67', component.options)
    } else {
      api.reload('2ab13a67', component.options)
    }
    module.hot.accept("./ImpBusAgePdfPop.vue?vue&type=template&id=2ab13a67", function () {
      api.rerender('2ab13a67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/popup/ImpBusAgePdfPop.vue"
export default component.exports